export const translation = {
  zenit: {
    ru: {
      siteTitle: "Ставь на US Open 2021!",
      rulesBtnText: "Правила",
      titleLine1: "Гарантированный*",
      titleLine2: "Кешбэк",
      titleLine3: "на US Open",
      titleLine4: "каждый день",
      btnGet: "Участвовать",
      conditionSpan1: "Регистрируйся",
      conditionText1: "или авторизуйся на сайте",
      conditionText2: "Ставь на",
      conditionSpan2: "US Open",
      conditionSpan3: "Забирай кешбэк",
      conditionText3: "каждый день",
      bkString: "Букмекерская контора Зенит",
      rightString: "Все права защищены",
      footnoteText: '*подробнее в правилах Акции',
      supportText: "Служба поддержки:",
      supportSpan: "8 (800) 222-22-12",
      rulesHeaderText: "Правила участия в Акции",
      paragraph1: '1. Акция проводится с 30.08.2021 г. по 12.09.2021 г.',
      paragraph2: '2. Сроки проведения Акции устанавливаются БК «Зенит» и могут быть изменены в любое время без указания причин и дополнительных уведомлений.',
      paragraph3: '3. Участнику Акции необходимо в период проведения Акции зарегистрироваться или авторизоваться на сайте zenitbet.com, а также обязательно подтвердить свое участие в Акции нажатием на кнопку «Участвовать».',
      paragraph4: '4. Кешбэк начисляется в виде фрибета.',
      paragraph5: '5. Условия начисления фрибета (бесплатной ставки):',
      paragraph6: '6. Бонусы не начисляются в следующих случаях:',
      paragraph7: '7. БК «Зенит» вправе отказать участнику Акции в начислении фрибета (бесплатной ставки), а также отстранить участника от участия в любых Акциях компании, признать недействительными любые действия участника, в отношении которого у БК «Зенит» возникли обоснованные подозрения в том, что он заведомо недобросовестно осуществляет права на участие в Акции или злоупотребляет ими, искажает данные или извлекает выгоду из любой подделки данных, необходимых для участия в Акции, в том числе, но не ограничиваясь следующими действиями:',
      paragraph8: '8. В случае обнаружения любого из нарушений правил Акции БК «Зенит» вправе запретить участнику получение фрибетов, аннулировать выигрыши, полученные с использованием бесплатных ставок и заблокировать аккаунт участника Акции.',
      paragraph9: '9. Условия использования фрибетов:',
      paragraph10: '10. В случае выигрыша ставки, оплаченной суммой фрибета, участнику Акции выплачивается только сумма выигрыша без учета суммы фрибета. Фрибет повторно не используется.',
      paragraph11: '11. Условия Акции могут быть изменены и дополнены в любое время без указания причин и дополнительных уведомлений.',
      paragraph12: '12. Использование фрибета подразумевает полное согласие участника Акции с настоящими Правилами.',
      tableLeftTopText:'Количество бонусов за день',
      tableCenterTopText:'Сумма бесплатной ставки (фрибет) в валюте',
      tableCurrencyRub:'RUB',
      tableCurrencyUsd:'USD',
      tableCurrencyEur:'EUR',
      tableCurrencyIrr:'IRR',
      tableCurrencyBrl:'BRL',
      tableCurrencyUah:'UAH',
      tableCurrencyKzt:'KZT',
      tableCurrencyPrb:'PRB',
      tableCurrencyTmt:'TMT',
      tableCurrencyMdl:'MDL',
      subParagraph51: '5.1. В Акции участвуют ставки, сделанные на любые события турнира US Open.',
      subParagraph52: '5.2. За все ставки из п.п. 5.1. Участнику Акции ежедневно начисляются бонусы в количестве:',
      subInnerParagraph521: '5.2.1. Выигрышная ставка: сумма выигрыша (эквивалент в рублях)*1%.',
      subInnerParagraph522: '5.2.2. Проигрышная ставка: сумма ставки (эквивалент в рублях)*5%.',
      subParagraph53: '5.3. За полученные бонусы Участнику Акции ежедневно будет начисляться фрибет. Сумма фрибета зависит от количества накопленных за день бонусов:',
      subParagraph54: '5.4. Если количество бонусов, накопленных за день меньше 100, бесплатная ставка не выдается.',
      subParagraph55: '5.5. Бесплатные ставки начисляются ежедневно с 00:00 до 03:00 UTC+3.',
      subParagraph61: '6.1. Ставка сделана на любой другой турнир, кроме US Open.',
      subParagraph62: '6.2. Ставка сделана с использованием бесплатной ставки.',
      subParagraph63: '6.3. Ставка уже была учтена в других акциях компании.',
      subParagraph64: '6.4. Ставка была продана участником Акции.',
      subParagraph91: '9.1. Фрибет может быть использован после проверки соответствия условиям, указанным в п. 5 настоящих Правил, в течение 7 дней.',
      subParagraph92: '9.2. Совершить бесплатную ставку можно только на всю сумму фрибета.',
      subParagraphLetter71: 'а) участник был уличен в действиях, которые повлекли или могут повлечь за собой неблагоприятные последствия различного типа и степени как для БК «Зенит», так и для иных участников и для третьих лиц;',
      subParagraphLetter72: 'б) в случае выявления факта предоставления участником сведений, не соответствующих действительности;',
      subParagraphLetter73: 'в) участник нарушает Правила Акции;',
      subParagraphLetter74: 'г) участник Акции нарушает Правила азартной игры и/или иные установленные правила;',
      subParagraphLetter75: 'д) аккаунт участника Акции заблокирован.',
    },
    kz: {
      siteTitle: "US Open 2021 үшін ұтыс тік!",
      rulesBtnText: "Ережелер",
      titleLine1: "Күн сайын",
      titleLine2: "US Open",
      titleLine3: "үшін кепілдікті*",
      titleLine4: "кешбэк",
      btnGet: "ҚАТЫСУ",
      conditionSpan1: "Сайтта тіркел",
      conditionText1: "немесе авторизациядан өт",
      conditionSpan2: "US Open",
      conditionText2: "үшін бәс тік",
      conditionText3: "Күн сайын",
      conditionSpan3: "кешбэк ал",
      bkString: "Зенит букмекерлік кеңсесі",
      rightString: "Барлық құқық қорғалған",
      footnoteText: '*толығырақ Акция ережелерінде',
      supportText: "Қолдау көрсету қызметі:",
      supportSpan: "8 (800) 222-22-12",
      rulesHeaderText: "Акцияға қатысу ережелері",
      paragraph1: '1. Акция 30.08.2021 ж. және 12.09.2021 ж. аралығында өткізіледі.',
      paragraph2: '2. Акцияны өткізу мерзімін «Зенит» БК белгілейді және себебін түсіндірместен және қосымша хабарландыру жасамай кез келген уақытта өзгертілуі мүмкін.',
      paragraph3: '3. Акция қатысушысына Акция өткізілу барысында zenitbet.com сайтында тіркелу немесе авторизациядан өту, сондай-ақ «Қатысу» түймесін басу арқылы өзінің Акцияға қатысатынын растау қажет.',
      paragraph4: '4. Кешбэк фрибет түрінде есептеледі.',
      paragraph5: '5. Фрибетті (тегін ұтысты) есептеу шарттары:',
      paragraph6: '6. Бонустар келесі жағдайларда есептелмейді:',
      paragraph7: '7. «Зенит» БК акцияға қатысушыға фрибетті (тегін бәсті) есептеуден бас тартуға құқылы, сонымен қатар «Зенит» БК акцияға қатысу құқығын дұрыс пайдаланбайтын немесе ережелерге немқұрайлы қарайтын, акцияға қатысуға қажетті деректерді қолмен жасайтын немесе жалған деректер арқылы пайда көргісі келетін қатысушыларды компания келесі әрекеттермен шектелмей, ұйымдастырған кез келген акциядан шеттетуге құқығы бар, сонымен қатар:',
      paragraph8: '8. Акция ережелері кез келген жолмен бұзылған жағдайда, «Зенит» БК қатысушының фрибеттерді алуына тыйым салуға, тегін ұтыстарды қолданып алынған ұтыстарды жоюға және Акцияға қатысушының аккаунтын бұғаттауға құқылы.',
      paragraph9: '9. Фрибеттерді пайдалану шарттары:',
      paragraph10: '10. Фрибет сомасымен төленген ұтысты ұтып алған жағдайда, Акцияға қатысушыға фрибеттер сомасын қоспағанда тек ұтыс сомасы ғана төленеді. Фрибет қайта қолданылмайды.',
      paragraph11: '11. Акцияның шарттары кез келген уақытта себебін түсіндірместен және алдын ала хабарландырмай өзгеруі және толықтырылуы мүмкін.',
      paragraph12: '12. Фрибетті қолдану акцияға қатысушының осы Ережелермен толығымен келісетінін білдіреді.',
      tableLeftTopText:'Бір күнгі бонустар саны',
      tableCenterTopText:'Тегін ұтыстың (фрибеттің) валютамен сомасы',
      tableCurrencyRub:'RUB',
      tableCurrencyUsd:'USD',
      tableCurrencyEur:'EUR',
      tableCurrencyIrr:'IRR',
      tableCurrencyBrl:'BRL',
      tableCurrencyUah:'UAH',
      tableCurrencyKzt:'KZT',
      tableCurrencyPrb:'PRB',
      tableCurrencyTmt:'TMT',
      tableCurrencyMdl:'MDL',
      subParagraph51: '5.1. Акцияға кез келген US Open турнирінің оқиғаларына тігілген ұтыстар қатысады.',
      subParagraph52: '5.2. 5.1 тармақшаларының барлық ұтыстары үшін. Акция қатысушысына күн сайын мына мөлшерде бонустар есептеледі:',
      subInnerParagraph521: '5.2.1. Ұтыстық тігілетін ұтыс: ұтыс сомасы (рубльдермен баламасы)*1%.',
      subInnerParagraph522: '5.2.2. Ұтылысты тігілетін ұтыс: ұтыс сомасы (рубльдермен баламасы)*5%.',
      subParagraph53: '5.3. Алынған бонустар үшін Акция Қатысушысына күн сайын фрибет есептеледі. Фрибет сомасы бір күнде жиналған бонустар санына байланысты болады:',
      subParagraph54: '5.4. Бір күнде жиналған бонустардың саны 100-ден аз болса, тегін ұтыс берілмейді.',
      subParagraph55: '5.5. Тегін ұтыстар күн сайын 00:00 және 03:00 аралығында UTC+3 есептеледі.',
      subParagraph61: '6.1. Ұтыс US Open-нен басқа кез келген басқа турнирге тігіледі.',
      subParagraph62: '6.2. Ұтыс тегін ұтысты қолданып тігілген.',
      subParagraph63: '6.3. Ұтыс әлдеқашан компанияның басқа акцияларында есепке алынған.',
      subParagraph64: '6.4. Ұтыс Акцияға қатысушымен сатылған.',
      subParagraph91: '9.1. Фрибетті 7 күн барысында осы Ережелердің 5-тармағында көрсетілген шарттарға сәйкестігі тексерілгеннен кейін пайдалануға болады.',
      subParagraph92: '9.2. Тегін ұтысты тек фрибеттің бүкіл сомасына тігуге болады.',
      subParagraphLetter71: 'а) қатысушы «Зенит» БК үшін де, басқа қатысушылар үшін де, үшінші тұлғалар үшін де әртүрлі түрдегі және дәрежедегі жағымсыз салдарға әкеп соқтырған немесе әкеп соғуы мүмкін әрекеттерді орындаған;',
      subParagraphLetter72: 'б) шындыққа сәйкес келмейтін ақпаратты ұсынғаны туралы факт анықталған жағдайда;',
      subParagraphLetter73: 'в) қатысушы Акция ережелерін бұзады;',
      subParagraphLetter74: 'г) Акцияға қатысушы құмар ойындарының ережелерін және/немесе басқа белгіленген ережелерді бұзады;',
      subParagraphLetter75: 'д) Акцияға қатысушының аккаунты бұғатталған.',
    },
    ua: {
      siteTitle: "Ставь на US Open 2021!",
      rulesBtnText: "Правила",
      titleLine1: "Гарантированный*",
      titleLine2: "Кешбэк",
      titleLine3: "на US Open",
      titleLine4: "каждый день",
      btnGet: "Участвовать",
      conditionSpan1: "Регистрируйся",
      conditionText1: "или авторизуйся на сайте",
      conditionText2: "Ставь на",
      conditionSpan2: "US Open",
      conditionSpan3: "Забирай кешбэк",
      conditionText3: "каждый день",
      bkString: "Букмекерская контора Зенит",
      rightString: "Все права защищены",
      footnoteText: '*подробнее в правилах Акции',
      supportText: "Служба поддержки:",
      supportSpan: "8 (800) 222-22-12",
      rulesHeaderText: "Правила участия в Акции",
      paragraph1: '1. Акция проводится с 30.08.2021 г. по 12.09.2021 г.',
      paragraph2: '2. Сроки проведения Акции устанавливаются БК «Зенит» и могут быть изменены в любое время без указания причин и дополнительных уведомлений.',
      paragraph3: '3. Участнику Акции необходимо в период проведения Акции зарегистрироваться или авторизоваться на сайте zenitbet.com, а также обязательно подтвердить свое участие в Акции нажатием на кнопку «Участвовать».',
      paragraph4: '4. Кешбэк начисляется в виде фрибета.',
      paragraph5: '5. Условия начисления фрибета (бесплатной ставки):',
      paragraph6: '6. Бонусы не начисляются в следующих случаях:',
      paragraph7: '7. БК «Зенит» вправе отказать участнику Акции в начислении фрибета (бесплатной ставки), а также отстранить участника от участия в любых Акциях компании, признать недействительными любые действия участника, в отношении которого у БК «Зенит» возникли обоснованные подозрения в том, что он заведомо недобросовестно осуществляет права на участие в Акции или злоупотребляет ими, искажает данные или извлекает выгоду из любой подделки данных, необходимых для участия в Акции, в том числе, но не ограничиваясь следующими действиями:',
      paragraph8: '8. В случае обнаружения любого из нарушений правил Акции БК «Зенит» вправе запретить участнику получение фрибетов, аннулировать выигрыши, полученные с использованием бесплатных ставок и заблокировать аккаунт участника Акции.',
      paragraph9: '9. Условия использования фрибетов:',
      paragraph10: '10. В случае выигрыша ставки, оплаченной суммой фрибета, участнику Акции выплачивается только сумма выигрыша без учета суммы фрибета. Фрибет повторно не используется.',
      paragraph11: '11. Условия Акции могут быть изменены и дополнены в любое время без указания причин и дополнительных уведомлений.',
      paragraph12: '12. Использование фрибета подразумевает полное согласие участника Акции с настоящими Правилами.',
      tableLeftTopText:'Количество бонусов за день',
      tableCenterTopText:'Сумма бесплатной ставки (фрибет) в валюте',
      tableCurrencyRub:'RUB',
      tableCurrencyUsd:'USD',
      tableCurrencyEur:'EUR',
      tableCurrencyIrr:'IRR',
      tableCurrencyBrl:'BRL',
      tableCurrencyUah:'UAH',
      tableCurrencyKzt:'KZT',
      tableCurrencyPrb:'PRB',
      tableCurrencyTmt:'TMT',
      tableCurrencyMdl:'MDL',
      subParagraph51: '5.1. В Акции участвуют ставки, сделанные на любые события турнира US Open.',
      subParagraph52: '5.2. За все ставки из п.п. 5.1. Участнику Акции ежедневно начисляются бонусы в количестве:',
      subInnerParagraph521: '5.2.1. Выигрышная ставка: сумма выигрыша (эквивалент в рублях)*1%.',
      subInnerParagraph522: '5.2.2. Проигрышная ставка: сумма ставки (эквивалент в рублях)*5%.',
      subParagraph53: '5.3. За полученные бонусы Участнику Акции ежедневно будет начисляться фрибет. Сумма фрибета зависит от количества накопленных за день бонусов:',
      subParagraph54: '5.4. Если количество бонусов, накопленных за день меньше 100, бесплатная ставка не выдается.',
      subParagraph55: '5.5. Бесплатные ставки начисляются ежедневно с 00:00 до 03:00 UTC+3.',
      subParagraph61: '6.1. Ставка сделана на любой другой турнир, кроме US Open.',
      subParagraph62: '6.2. Ставка сделана с использованием бесплатной ставки.',
      subParagraph63: '6.3. Ставка уже была учтена в других акциях компании.',
      subParagraph64: '6.4. Ставка была продана участником Акции.',
      subParagraph91: '9.1. Фрибет может быть использован после проверки соответствия условиям, указанным в п. 5 настоящих Правил, в течение 7 дней.',
      subParagraph92: '9.2. Совершить бесплатную ставку можно только на всю сумму фрибета.',
      subParagraphLetter71: 'а) участник был уличен в действиях, которые повлекли или могут повлечь за собой неблагоприятные последствия различного типа и степени как для БК «Зенит», так и для иных участников и для третьих лиц;',
      subParagraphLetter72: 'б) в случае выявления факта предоставления участником сведений, не соответствующих действительности;',
      subParagraphLetter73: 'в) участник нарушает Правила Акции;',
      subParagraphLetter74: 'г) участник Акции нарушает Правила азартной игры и/или иные установленные правила;',
      subParagraphLetter75: 'д) аккаунт участника Акции заблокирован.',
    },
    en: {
      siteTitle: "Place bets on US Open 2021!",
      rulesBtnText: "Rules",
      titleLine1: "Guaranteed*",
      titleLine2: "cashback",
      titleLine3: `for Betting
        on US Open`,
      titleLine4: "every day",
      btnGet: "Participate",
      conditionSpan1: "Sign in",
      conditionSpan1Extra: "or",
      conditionSpan1Part2: "register",
      conditionText1: "on the website",
      conditionText2: "Bet",
      conditionText2Extra: "on",
      conditionSpan2: "US Open",
      conditionExtra3: "Get",
      conditionSpan3: "cashback",
      conditionText3: "every day",
      bkString: "Bookmaker Zenit",
      rightString: "All rights reserved",
      footnoteText: '*read more in Terms and Conditions of the Promotion',
      supportText: "Support center:",
      supportSpan: "8 (800) 222-22-12",
      rulesHeaderText: "Terms and conditions of the Promotion",
      paragraph1: '1. The Promotion lasts from 30 August 2021 to 12 September 2021.',
      paragraph2: '2. The dates of the Promotion are determined by Bookmaker Zenit and may be changed at any time for any reason and without additional notification.',
      paragraph3: '3. To take part in the Promotion, you must sign in or register at zenitbet.com during the Promotion dates.',
      paragraph4: '4. Cashback is credited as a free bet.',
      paragraph5: '5. Terms of receiving a free bet:',
      paragraph6: '6. Bonuses shall not be credited if the following has occurred:',
      paragraph7: `7. Bookmaker Zenit reserves the right to cancel the free bet accrual, suspend a participant from taking part in any of the Bookmaker's Promotions and declare any of their activities invalid if Bookmaker Zenit reasonably suspects that they have knowingly fulfilled the Promotion requirements in bad faith, abused the Promotion, falsified information or taken advantage of any falsified information required to participate in the Promotion, including but not limited to the following:`,
      paragraph8: `8. If Bookmaker Zenit discovers that any of the Promotion Terms and conditions have been violated, the Bookmaker is entitled to cancel the Participant's right to receive free bets, annul any winnings from the free bets and block the Participant's account.`,
      paragraph9: '9. Conditions for using the free bet:',
      paragraph10: '10. If you win, only the net profit is paid out, i.e. the free bet amount is subtracted out of your winnings. The free bet can only be used once.',
      paragraph11: '11. Terms and conditions of the Promotion can be changed at any time without providing a reason or additional notifications.',
      paragraph12: '12. By using the free bet option, you fully agree to these Terms and conditions.',
      tableLeftTopText:'Number of bonuses per day',
      tableCenterTopText:'Free bet amount (in currencies)',
      tableCurrencyRub:'RUB',
      tableCurrencyUsd:'USD',
      tableCurrencyEur:'EUR',
      tableCurrencyIrr:'IRR',
      tableCurrencyBrl:'BRL',
      tableCurrencyUah:'UAH',
      tableCurrencyKzt:'KZT',
      tableCurrencyPrb:'PRB',
      tableCurrencyTmt:'TMT',
      tableCurrencyMdl:'MDL',
      noFreebetText: 'free bet shall not be credited',
      subParagraph51: `5.1. Only bets placed on the championship's principal events shall be counted: US Open.`,
      subParagraph52: '5.2. For each bet specified in Clause 5.1, you shall be credited bonuses daily according to the following:',
      subInnerParagraph521: '5.2.1. Winning bet: profit (equivalent in RUB)*1%.',
      subInnerParagraph522: '5.2.2. Losing bet: bet amount (equivalent in RUB)*5%.',
      subParagraph53: '5.3. For received bonuses, you shall be credited a free bet daily. The free bet amount shall vary based on the number of bonuses you have received:',
      subParagraph54: '5.4. Free bet shall not be credited if the number of bonuses accumulated per day is less than 100.',
      subParagraph55: '5.5. Free bets are credited daily from 12 a.m. to 3 a.m. (UTC+03:00).',
      subParagraph61: '6.1. The bet has been placed on any other championship apart from US Open.',
      subParagraph62: '6.2. The bet has been placed using a free bet.',
      subParagraph63: '6.3. The bet has already been counted under a different promotion of the bookmaker.',
      subParagraph64: '6.4. The bet has been sold by the participant, given the sale of bets is stipulated by the Bet acceptance rules.',
      subParagraph91: '9.1. The free bet can be used after being checked for compliance with the requirements specified in Clause 5 of these Terms and conditions within 7 days.',
      subParagraph92: '9.2. You can only use the free bet in its entirety to place a bet.',
      subParagraphLetter71: 'a) the participant has been found to have performed actions that caused or may have caused adverse effects of any kind and extent for Bookmaker Zenit, other participants and/or third parties;',
      subParagraphLetter72: 'b) the Participant has been found to have provided incorrect information;',
      subParagraphLetter73: 'c) the Participant has violated the Terms and conditions of the Promotion;',
      subParagraphLetter74: 'd) the Participant has violated the gambling rules and/or any other rules in effect;',
      subParagraphLetter75: `e) the Participant's account has been blocked.`,
    },
    br: {
      siteTitle: "Place bets on US Open 2021!",
      rulesBtnText: "regras",
      titleLine1: "Dinheiro",
      titleLine2: "garantido*",
      titleLine3: `por fazer apostas 
      no US Open`,
      titleLine4: "todos os dias",
      btnGet: "PARTICIPE",
      conditionSpan1: "Faça login",
      conditionSpan1Extra: "ou ",
      conditionSpan1Part2: "cadastre-se ",
      conditionText1: "no site",
      conditionText2: "Aposte ",
      conditionText2Extra: "no",
      conditionSpan2: "US Open",
      conditionExtra3: "Receba",
      conditionSpan3: "dinheiro ",
      conditionText3: "todos os dias",
      bkString: "Casa de Apostas Zenit",
      rightString: "Todos os direitos reservados",
      footnoteText: '*leia mais nos Termos e Condições da Promoção',
      supportText: "Central de suporte",
      supportSpan: "8 (800) 222-22-12",
      rulesHeaderText: "Termos e Condições da Promoção",
      paragraph1: '1. A Promoção vai de 30 de agosto de 2021 a 12 de setembro de 2021.',
      paragraph2: '2. As datas da Promoção são determinadas pela ccasa de apostas Zenit e podem ser alteradas a qualquer momento por qualquer motivo e sem notificação adicional.',
      paragraph3: '3. Para participar da Promoção, você deve se cadastrar no site zenitbet.com durante a Promoção e confirmar sua participação na Promoção clicando em Participar.',
      paragraph4: '4. O dinheiro é creditado na forma de uma aposta grátis.',
      paragraph5: '5. Termos para receber uma aposta grátis:',
      paragraph6: '6. Os bônus não serão creditados se o seguinte ocorrer:',
      paragraph7: `7. A casa de apostas Zenit reserva-se o direito de cancelar a acumulação de apostas grátis, suspender um participante de qualquer uma das Promoções da casa de apostas e declarar qualquer uma das suas atividades inválida se a casa de apostas Zenit suspeitar razoavelmente que cumpriu conscientemente os requisitos da Promoção de má-fé, abusou do Promoção, falsificou informações ou tirou proveito de qualquer informação falsificada necessária para participar da Promoção, incluindo, mas não se limitando ao seguinte:`,
      paragraph8: `8. Se a casa de apostas Zenit descobrir que algum dos Termos e condições da Promoção foi violado, a casa de apostas tem o direito de cancelar o direito do participante de receber apostas grátis, anular quaisquer ganhos das apostas grátis e bloquear a conta do participante.`,
      paragraph9: '9. Condições para usar a aposta grátis:',
      paragraph10: '10. Se você ganhar, apenas o lucro líquido será pago, ou seja, o valor da aposta grátis será subtraído de seus ganhos. A aposta grátis só pode ser usada uma vez.',
      paragraph11: '11. Os Termos e condições da Promoção podem ser alterados a qualquer momento sem fornecer um motivo ou notificações adicionais.',
      paragraph12: '12. Ao usar uma aposta grátis, você concorda totalmente com estes Termos e condições.',
      tableLeftTopText:'Número de bônus por dia',
      tableCenterTopText:'Valor da aposta grátis (em moedas)',
      tableCurrencyRub:'RUB',
      tableCurrencyUsd:'USD',
      tableCurrencyEur:'EUR',
      tableCurrencyIrr:'IRR',
      tableCurrencyBrl:'BRL',
      tableCurrencyUah:'UAH',
      tableCurrencyKzt:'KZT',
      tableCurrencyPrb:'PRB',
      tableCurrencyTmt:'TMT',
      tableCurrencyMdl:'MDL',
      noFreebetText: 'a aposta grátis não será creditada',
      subParagraph51: `5.1. As apostas em qualquer evento do US Open participam da Promoção.`,
      subParagraph52: '5.2. Para cada aposta especificada na Cláusula 5.1, você receberá bônus diários de acordo com o seguinte:',
      subInnerParagraph521: '5.2.1. Aposta vencedora: lucro (equivalente em RUB)*1%.',
      subInnerParagraph522: '5.2.2. Aposta perdedora: valor da aposta (equivalente em RUB)*5%',
      subParagraph53: '5.3. Para os bônus recebidos, você receberá uma aposta grátis diária. O valor da aposta grátis depende do número de bônus acumulados durante um dia:',
      subParagraph54: '5.4. Se o número de bônus acumulados por dia for inferior a 100, a aposta grátis não será creditada',
      subParagraph55: '5.5. As apostas grátis são creditadas diariamente entre 0h e 3h (UTC + 3h).',
      subParagraph61: '6.1. Você fez uma aposta em qualquer competição diferente do US Open.',
      subParagraph62: '6.2. A aposta foi feita usando uma aposta grátis.',
      subParagraph63: '6.3. A aposta já foi contabilizada com outra promoção da casa de apostas.',
      subParagraph64: '6.4. A aposta foi vendida pelo participante da Promoção.',
      subParagraph91: '9.1. A aposta grátis pode ser usada após ser verificada a conformidade com os requisitos especificados na Cláusula 5 destes Termos e Condições dentro de 7 dias.',
      subParagraph92: '9.2. Você só pode usar a aposta grátis em sua totalidade para fazer uma aposta.',
      subParagraphLetter71: 'a) o participante tenha realizado ações que causaram ou podem ter causado efeitos adversos de qualquer tipo e extensão para a casa de apostas Zenit, outros participantes e/ou terceiros;',
      subParagraphLetter72: 'b) o participante tenha fornecido informações incorretas;',
      subParagraphLetter73: 'c) o participante violou os Termos e condições da Promoção;',
      subParagraphLetter74: 'd) o participante violou as regras de aposta e/ou quaisquer outras regras em vigor;',
      subParagraphLetter75: `e) a conta do participante foi bloqueada.`,
    },
    ir: {
      siteTitle: "Place bets on US Open 2021!",
      rulesBtnText: "قوانین",
      titleLine1: "تضمین*",
      titleLine2: " بازپرداخت",
      titleLine3: ` بازپرداخت وجه با شرط‌بندی روزانه بر`,
      titleLine4: " تنیس آزاد آمریکا",
      btnGet: "شرکت",
      conditionSpan1: "در وب‌سایت ",
      conditionSpan1Extra: "ثبت‌نام کنید",
      conditionSpan1Part2: "یا وارد شوید ",
      conditionText1: "",
      conditionText2: "شرط ببندید",
      conditionText2Extra: "روی تنیس",
      conditionSpan2: "آزاد آمریکا ",
      conditionSpan3: "هر روز",
      conditionExtra3: " بازپرداخت وجه",
      conditionText3: "خود را دریافت کنید",
      bkString: "بنگاه شرط‌بندی Zenit",
      rightString: "تمامی حقوق محفوظ است",
      footnoteText: '*مطالعه جزئیات در خصوص شرایط و ضوابط این طرح تشویقی',
      supportText: "مرکز پشتیبان",
      supportSpan: "8 (800) 222-22-12",
      rulesHeaderText: "شرایط و ضوابط جشنواره ",
      paragraph1: '1. مهلت جشنواره از ۳۰ اوت ۲۰۲۱ تا ۱۲ دسامبر ۲۰۲۱ است.',
      paragraph2: '2. تاریخ‌های جشنواره توسط بنگاه Zenit تعیین می‌شوند و ممکن است در هر زمانی و به هر دلیلی بدون اطلاع تغییر کنند.',
      paragraph3: '3. برای مشارکت در جشنواره باید در وبسایت zenitbet.com در حین جشنواره ثبت نام کنید و مشارکت خود را در جشنواره با کلیک روی گزینه‌ی «مشارکت» تایید کنید.',
      paragraph4: '4. کش‌بک به صورت شرط رایگان اعتبار داده می‌شود.',
      paragraph5: '5. شرایط دریافت شرط رایگان:',
      paragraph6: '6. پاداش‌ها در صورت بروز موارد زیر داده نمی‌شوند:',
      paragraph7: `7. بنگاه Zenit حق دارد مجموع مبالغ شرط رایگان را لغو کند، فردی را از شرکت در هرکدام از جشنواره‌های بنگاه معلق کند، و فعالیت‌ها آن فرد را نامعتبر اعلام کند اگر بنگاه Zenit شک مستدل داشته باشد که فرد عامدانه الزامات جشنواره را با قصد بد برآورده کرده، از جشنواره سوءاستفاده کرده، اطلاعات اشتباه ارائه‌داده یا از اطلاعات اشتباهی که برای شرکت در جشنواره لازم بوده‌اند سوءاستفاده کرده است. از جمله موارد زیر:`,
      paragraph8: `8. گر بنگاه Zenit آگاه شود که از شرایط و ضوابط جشنواره تخطی شده است، می‌تواند حق دریافت شرط‌های رایگان را برای فرد لغو کند، هر بردی از شرط‌های رایگان را نفی کند و حساب فرد را مسدود نماید.`,
      paragraph9: '9.شرایط استفاده از شرط رایگان:',
      paragraph10: '10. در صورت برد، فقط سود خالص پرداخت می‌شود، به عبارت دیگر، مبلغ شرط رایگان از بردهای شما کسر خواهد شد. از شرط رایگان فقط یکبار می‌توان استفاده کرد.',
      paragraph11: '11. شرایط و ضوابط جشنواره ممکن است در هر زمانی بدون ارائه دلیل یا اطلاع قبلی تغییر کنند.',
      paragraph12: '12. استفاده از شرط رایگان به‌معنی پذیرش شرایط و ضوابط جشنواره است.',
      tableLeftTopText:'تعداد پاداش‌ها در هر روز',
      tableCenterTopText:'مبلغ شرط رایگان (به ارزهای)',
      tableCurrencyRub:'RUB',
      tableCurrencyUsd:'USD',
      tableCurrencyEur:'EUR',
      tableCurrencyIrr:'IRR',
      tableCurrencyBrl:'BRL',
      tableCurrencyUah:'UAH',
      tableCurrencyKzt:'KZT',
      tableCurrencyPrb:'PRB',
      tableCurrencyTmt:'TMT',
      tableCurrencyMdl:'MDL',
      noFreebetText: 'شرط رایگان اعطا نخواهد شد',
      subParagraph51: `5.1. شرط روی هر رویدادی در اوپن آمریکا در جشنواره شرکت داده خواهد شد.`,
      subParagraph52: '5.2. برای هر شرطِ ذکرشده در بند ۵.۱ پاداش‌های روزانه دریافت خواهید کرد؛ مطابق با قوانین زیر:',
      subInnerParagraph521: '5.2.1. شرط برنده: سود (معادل به روبل)*۱%.',
      subInnerParagraph522: '5.2.2. شرط بازنده: مبلغ شرط (معادل به روبل)*۵%.',
      subParagraph53: '5.3. در ازای دریافت پاداش به شما روزانه یک شرط رایگان اعتبار داده می‌شود. مبلغ شرط رایگان بسته به تعداد پاداش‌های جمع‌شده طی یک روز دارد:',
      subParagraph54: '5.4. اگر تعداد پاداش‌های جمع‌شده در هر روز کمتر از صد باشد، شرط رایگان اعطا نخواهد شد.',
      subParagraph55: '5.5. شرط‌های رایگان هر روز بین ۱۲ ظهر تا ۳ صبح (به وقت UTC+۰۳:۰۰) داده می‌شوند',
      subParagraph61: '6.1. در رویدادی غیر از اوپن آمریکا شرط بسته باشید. ',
      subParagraph62: '6.2. شرط با استفاده از شرط رایگان بسته شده است.',
      subParagraph63: '6.3. شرط در جشنواره دیگری از بنگاه محاسبه شده است.',
      subParagraph64: '6.4. شرط توسط شرکت‌کننده‌ی جشنواره فروخته شده باشد. ',
      subParagraph91: '9.1. طی هفت روز، بعد از بررسی جهت تطابق شرط با معیارهای مشروح در بند ۵ از این شرایط و ضوابط می‌توان از شرط رایگان استفاده کرد.',
      subParagraph92: '9.2. باید از تمام شرط رایگان برای بستن شرط استفاده کرد.',
      subParagraphLetter71: 'a) فرد اقداماتی داشته که مستقیم یا غیرمستقیم منجر به تاثیر منفی، از هر نوعی و دامنه‌ای، برای بنگاه Zenit، دیگر مشترکین و/یا اشخاص ثالث شده‌اند؛',
      subParagraphLetter72: 'b) فرد اطلاعات غلط ارائه کرده باشد؛',
      subParagraphLetter73: 'c) فرد از شرایط و ضوابط جشنواره تخطی کرده باشد؛',
      subParagraphLetter74: 'd) فرد قوانین بازی و/یا دیگر قوانین را در عمل زیرپا گذاشته است؛',
      subParagraphLetter75: `e) حساب فرد مسدود شده است.`,
    }
  },
  zenbet: {
    en: {
      siteTitle: "Place bets on US Open 2021!",
      rulesBtnText: "Rules",
      titleLine1: "Guaranteed*",
      titleLine2: "cashback",
      titleLine3: `for Betting
        on US Open`,
      titleLine4: "every day",
      btnGet: "Participate",
      conditionSpan1: "Sign in",
      conditionSpan1Extra: "or",
      conditionSpan1Part2: "register",
      conditionText1: "on the website",
      conditionText2: "Bet",
      conditionText2Extra: "on",
      conditionSpan2: "US Open",
      conditionExtra3: "Get",
      conditionSpan3: "cashback",
      conditionText3: "every day",
      bkString: "Bookmaker ZENBET",
      rightString: "All rights reserved",
      footnoteText: '*read more in Terms and Conditions of the Promotion',
      supportText: "Email: support@zen.bet",
      rulesHeaderText: "Terms and conditions of the Promotion",
      paragraph1: '1. The Promotion lasts from 30 August 2021 to 12 September 2021.',
      paragraph2: '2. The dates of the Promotion are determined by Bookmaker ZENBET and may be changed at any time for any reason and without additional notification.',
      paragraph3: '3. To take part in the Promotion, you must sign in or register at zen.bet during the Promotion dates.',
      paragraph4: '4. Cashback is credited as a free bet.',
      paragraph5: '5. Terms of receiving a free bet:',
      paragraph6: '6. Bonuses shall not be credited if the following has occurred:',
      paragraph7: `7. Bookmaker ZENBET reserves the right to cancel the free bet accrual, suspend a participant from taking part in any of the Bookmaker's Promotions and declare any of their activities invalid if Bookmaker ZENBET reasonably suspects that they have knowingly fulfilled the Promotion requirements in bad faith, abused the Promotion, falsified information or taken advantage of any falsified information required to participate in the Promotion, including but not limited to the following:`,
      paragraph8: `8. If Bookmaker ZENBET discovers that any of the Promotion Terms and conditions have been violated, the Bookmaker is entitled to cancel the Participant's right to receive free bets, annul any winnings from the free bets and block the Participant's account.`,
      paragraph9: '9. Conditions for using the free bet:',
      paragraph10: '10. If you win, only the net profit is paid out, i.e. the free bet amount is subtracted out of your winnings. The free bet can only be used once.',
      paragraph11: '11. Terms and conditions of the Promotion can be changed at any time without providing a reason or additional notifications.',
      paragraph12: '12. By using the free bet option, you fully agree to these Terms and conditions.',
      tableLeftTopText:'Number of bonuses per day',
      tableCenterTopText:'Free bet amount (in currencies)',
      tableCurrencyRub:'RUB',
      tableCurrencyUsd:'USD',
      tableCurrencyEur:'EUR',
      tableCurrencyIrr:'IRR',
      tableCurrencyBrl:'BRL',
      tableCurrencyUah:'UAH',
      tableCurrencyKzt:'KZT',
      tableCurrencyPrb:'PRB',
      tableCurrencyTmt:'TMT',
      tableCurrencyMdl:'MDL',
      noFreebetText: 'free bet shall not be credited',
      subParagraph51: `5.1. Only bets placed on the championship's principal events shall be counted: US Open.`,
      subParagraph52: '5.2. For each bet specified in Clause 5.1, you shall be credited bonuses daily according to the following:',
      subInnerParagraph521: '5.2.1. Winning bet: profit (equivalent in USD)*1%.',
      subInnerParagraph522: '5.2.2. Losing bet: bet amount (equivalent in USD)*5%.',
      subParagraph53: '5.3. For received bonuses, you shall be credited a free bet daily. The free bet amount shall vary based on the number of bonuses you have received:',
      subParagraph54: '5.4. Free bet shall not be credited if the number of bonuses accumulated per day is less than 2.',
      subParagraph55: '5.5. Free bets are credited daily from 12 a.m. to 3 a.m. (UTC+03:00).',
      subParagraph61: '6.1. The bet has been placed on any other championship apart from US Open.',
      subParagraph62: '6.2. The bet has been placed using a free bet.',
      subParagraph63: '6.3. The bet has already been counted under a different promotion of the bookmaker.',
      subParagraph64: '6.4. The bet has been sold by the participant, given the sale of bets is stipulated by the Bet acceptance rules.',
      subParagraph91: '9.1. The free bet can be used after being checked for compliance with the requirements specified in Clause 5 of these Terms and conditions within 7 days.',
      subParagraph92: '9.2. You can only use the free bet in its entirety to place a bet.',
      subParagraphLetter71: 'a) the participant has been found to have performed actions that caused or may have caused adverse effects of any kind and extent for Bookmaker ZENBET, other participants and/or third parties;',
      subParagraphLetter72: 'b) the Participant has been found to have provided incorrect information;',
      subParagraphLetter73: 'c) the Participant has violated the Terms and conditions of the Promotion;',
      subParagraphLetter74: 'd) the Participant has violated the gambling rules and/or any other rules in effect;',
      subParagraphLetter75: `e) the Participant's account has been blocked.`,
    },
    br: {
      siteTitle: "Place bets on US Open 2021!",
      rulesBtnText: "regras",
      titleLine1: "Dinheiro",
      titleLine2: "garantido*",
      titleLine3: `por fazer apostas 
      no US Open`,
      titleLine4: "todos os dias",
      btnGet: "PARTICIPE",
      conditionSpan1: "Faça login",
      conditionSpan1Extra: "ou ",
      conditionSpan1Part2: "cadastre-se ",
      conditionText1: "no site",
      conditionText2: "Aposte ",
      conditionText2Extra: "no",
      conditionSpan2: "US Open",
      conditionExtra3: "Receba",
      conditionSpan3: "dinheiro ",
      conditionText3: "todos os dias",
      bkString: "Casa de Apostas ZENBET",
      rightString: "Todos os direitos reservados",
      footnoteText: '*leia mais nos Termos e Condições da Promoção',
      supportText: "Email: support@zen.bet",
      rulesHeaderText: "Termos e Condições da Promoção",
      paragraph1: '1. A Promoção vai de 30 de agosto de 2021 a 12 de setembro de 2021.',
      paragraph2: '2. As datas da Promoção são determinadas pela ccasa de apostas ZENBET e podem ser alteradas a qualquer momento por qualquer motivo e sem notificação adicional.',
      paragraph3: '3. Para participar da Promoção, você deve se cadastrar no site zen.bet durante a Promoção e confirmar sua participação na Promoção clicando em Participar.',
      paragraph4: '4. O dinheiro é creditado na forma de uma aposta grátis.',
      paragraph5: '5. Termos para receber uma aposta grátis:',
      paragraph6: '6. Os bônus não serão creditados se o seguinte ocorrer:',
      paragraph7: `7. A casa de apostas ZENBET reserva-se o direito de cancelar a acumulação de apostas grátis, suspender um participante de qualquer uma das Promoções da casa de apostas e declarar qualquer uma das suas atividades inválida se a casa de apostas ZENBET suspeitar razoavelmente que cumpriu conscientemente os requisitos da Promoção de má-fé, abusou do Promoção, falsificou informações ou tirou proveito de qualquer informação falsificada necessária para participar da Promoção, incluindo, mas não se limitando ao seguinte:`,
      paragraph8: `8. Se a casa de apostas ZENBET descobrir que algum dos Termos e condições da Promoção foi violado, a casa de apostas tem o direito de cancelar o direito do participante de receber apostas grátis, anular quaisquer ganhos das apostas grátis e bloquear a conta do participante.`,
      paragraph9: '9. Condições para usar a aposta grátis:',
      paragraph10: '10. Se você ganhar, apenas o lucro líquido será pago, ou seja, o valor da aposta grátis será subtraído de seus ganhos. A aposta grátis só pode ser usada uma vez.',
      paragraph11: '11. Os Termos e condições da Promoção podem ser alterados a qualquer momento sem fornecer um motivo ou notificações adicionais.',
      paragraph12: '12. Ao usar uma aposta grátis, você concorda totalmente com estes Termos e condições.',
      tableLeftTopText:'Número de bônus por dia',
      tableCenterTopText:'Valor da aposta grátis (em moedas)',
      tableCurrencyRub:'RUB',
      tableCurrencyUsd:'USD',
      tableCurrencyEur:'EUR',
      tableCurrencyIrr:'IRR',
      tableCurrencyBrl:'BRL',
      tableCurrencyUah:'UAH',
      tableCurrencyKzt:'KZT',
      tableCurrencyPrb:'PRB',
      tableCurrencyTmt:'TMT',
      tableCurrencyMdl:'MDL',
      noFreebetText: 'a aposta grátis não será creditada',
      subParagraph51: `5.1. As apostas em qualquer evento do US Open participam da Promoção.`,
      subParagraph52: '5.2. Para cada aposta especificada na Cláusula 5.1, você receberá bônus diários de acordo com o seguinte:',
      subInnerParagraph521: '5.2.1. Aposta vencedora: lucro (equivalente em USD)*1%.',
      subInnerParagraph522: '5.2.2. Aposta perdedora: valor da aposta (equivalente em USD)*5%.',
      subParagraph53: '5.3. Para os bônus recebidos, você receberá uma aposta grátis diária. O valor da aposta grátis depende do número de bônus acumulados durante um dia:',
      subParagraph54: '5.4. Se o número de bônus acumulados por dia for inferior a 2, a aposta grátis não será creditada.',
      subParagraph55: '5.5. As apostas grátis são creditadas diariamente entre 0h e 3h (UTC + 3h).',
      subParagraph61: '6.1. Você fez uma aposta em qualquer competição diferente do US Open.',
      subParagraph62: '6.2. A aposta foi feita usando uma aposta grátis.',
      subParagraph63: '6.3. A aposta já foi contabilizada com outra promoção da casa de apostas.',
      subParagraph64: '6.4. A aposta foi vendida pelo participante da Promoção.',
      subParagraph91: '9.1. A aposta grátis pode ser usada após ser verificada a conformidade com os requisitos especificados na Cláusula 5 destes Termos e Condições dentro de 7 dias.',
      subParagraph92: '9.2. Você só pode usar a aposta grátis em sua totalidade para fazer uma aposta.',
      subParagraphLetter71: 'a) o participante tenha realizado ações que causaram ou podem ter causado efeitos adversos de qualquer tipo e extensão para a casa de apostas ZENBET, outros participantes e/ou terceiros;',
      subParagraphLetter72: 'b) o participante tenha fornecido informações incorretas;',
      subParagraphLetter73: 'c) o participante violou os Termos e condições da Promoção;',
      subParagraphLetter74: 'd) o participante violou as regras de aposta e/ou quaisquer outras regras em vigor;',
      subParagraphLetter75: `e) a conta do participante foi bloqueada.`,
    },
    ir: {
      siteTitle: "Place bets on US Open 2021!",
      rulesBtnText: "قوانین",
      titleLine1: "تضمین*",
      titleLine2: " بازپرداخت",
      titleLine3: ` بازپرداخت وجه با شرط‌بندی روزانه بر`,
      titleLine4: " تنیس آزاد آمریکا",
      btnGet: "شرکت",
      conditionSpan1: "در وب‌سایت ",
      conditionSpan1Extra: "ثبت‌نام کنید",
      conditionSpan1Part2: "یا وارد شوید ",
      conditionText1: "",
      conditionText2: "شرط ببندید",
      conditionText2Extra: "روی تنیس",
      conditionSpan2: "آزاد آمریکا ",
      conditionSpan3: "هر روز",
      conditionExtra3: " بازپرداخت وجه",
      conditionText3: "خود را دریافت کنید",
      bkString: "بنگاه شرط‌بندی ZENBET",
      rightString: "تمامی حقوق محفوظ است",
      footnoteText: '*مطالعه جزئیات در خصوص شرایط و ضوابط این طرح تشویقی',
      supportText: "Email: support@zen.bet",
      rulesHeaderText: "شرایط و ضوابط جشنواره ",
      paragraph1: '1. مهلت جشنواره از ۳۰ اوت ۲۰۲۱ تا ۱۲ دسامبر ۲۰۲۱ است.',
      paragraph2: '2. تاریخ‌های جشنواره توسط بنگاه ZENBET تعیین می‌شوند و ممکن است در هر زمانی و به هر دلیلی بدون اطلاع تغییر کنند.',
      paragraph3: '3. برای مشارکت در جشنواره باید در وبسایت zen.bet در حین جشنواره ثبت نام کنید و مشارکت خود را در جشنواره با کلیک روی گزینه‌ی «مشارکت» تایید کنید.',
      paragraph4: '4. کش‌بک به صورت شرط رایگان اعتبار داده می‌شود.',
      paragraph5: '5. شرایط دریافت شرط رایگان:',
      paragraph6: '6. پاداش‌ها در صورت بروز موارد زیر داده نمی‌شوند:',
      paragraph7: `7. بنگاه ZENBET حق دارد مجموع مبالغ شرط رایگان را لغو کند، فردی را از شرکت در هرکدام از جشنواره‌های بنگاه معلق کند، و فعالیت‌ها آن فرد را نامعتبر اعلام کند اگر بنگاه ZENBET شک مستدل داشته باشد که فرد عامدانه الزامات جشنواره را با قصد بد برآورده کرده، از جشنواره سوءاستفاده کرده، اطلاعات اشتباه ارائه‌داده یا از اطلاعات اشتباهی که برای شرکت در جشنواره لازم بوده‌اند سوءاستفاده کرده است. از جمله موارد زیر:`,
      paragraph8: `8. گر بنگاه ZENBET آگاه شود که از شرایط و ضوابط جشنواره تخطی شده است، می‌تواند حق دریافت شرط‌های رایگان را برای فرد لغو کند، هر بردی از شرط‌های رایگان را نفی کند و حساب فرد را مسدود نماید.`,
      paragraph9: '9.شرایط استفاده از شرط رایگان:',
      paragraph10: '10. در صورت برد، فقط سود خالص پرداخت می‌شود، به عبارت دیگر، مبلغ شرط رایگان از بردهای شما کسر خواهد شد. از شرط رایگان فقط یکبار می‌توان استفاده کرد.',
      paragraph11: '11. شرایط و ضوابط جشنواره ممکن است در هر زمانی بدون ارائه دلیل یا اطلاع قبلی تغییر کنند.',
      paragraph12: '12. استفاده از شرط رایگان به‌معنی پذیرش شرایط و ضوابط جشنواره است.',
      tableLeftTopText:'تعداد پاداش‌ها در هر روز',
      tableCenterTopText:'مبلغ شرط رایگان (به ارزهای)',
      tableCurrencyRub:'RUB',
      tableCurrencyUsd:'USD',
      tableCurrencyEur:'EUR',
      tableCurrencyIrr:'IRR',
      tableCurrencyBrl:'BRL',
      tableCurrencyUah:'UAH',
      tableCurrencyKzt:'KZT',
      tableCurrencyPrb:'PRB',
      tableCurrencyTmt:'TMT',
      tableCurrencyMdl:'MDL',
      noFreebetText: 'شرط رایگان اعطا نخواهد شد',
      subParagraph51: `5.1. شرط روی هر رویدادی در اوپن آمریکا در جشنواره شرکت داده خواهد شد.`,
      subParagraph52: '5.2. برای هر شرطِ ذکرشده در بند ۵.۱ پاداش‌های روزانه دریافت خواهید کرد؛ مطابق با قوانین زیر:',
      subInnerParagraph521: '5.2.1. شرط برنده: سود (معادل به دلار آمریکا)*۱%.',
      subInnerParagraph522: '5.2.2. شرط بازنده: مبلغ شرط (معادل به دلار آمریکا)*۵%.',
      subParagraph53: '5.3. در ازای دریافت پاداش به شما روزانه یک شرط رایگان اعتبار داده می‌شود. مبلغ شرط رایگان بسته به تعداد پاداش‌های جمع‌شده طی یک روز دارد:',
      subParagraph54: '5.4. اگر تعداد پاداش‌های جمع‌شده در هر روز کمتر از ۲ باشد، شرط رایگان اعطا نخواهد شد.',
      subParagraph55: '5.5. شرط‌های رایگان هر روز بین ۱۲ ظهر تا ۳ صبح (به وقت UTC+۰۳:۰۰) داده می‌شوند',
      subParagraph61: '6.1. در رویدادی غیر از اوپن آمریکا شرط بسته باشید. ',
      subParagraph62: '6.2. شرط با استفاده از شرط رایگان بسته شده است.',
      subParagraph63: '6.3. شرط در جشنواره دیگری از بنگاه محاسبه شده است.',
      subParagraph64: '6.4. شرط توسط شرکت‌کننده‌ی جشنواره فروخته شده باشد. ',
      subParagraph91: '9.1. طی هفت روز، بعد از بررسی جهت تطابق شرط با معیارهای مشروح در بند ۵ از این شرایط و ضوابط می‌توان از شرط رایگان استفاده کرد.',
      subParagraph92: '9.2. باید از تمام شرط رایگان برای بستن شرط استفاده کرد.',
      subParagraphLetter71: 'a) فرد اقداماتی داشته که مستقیم یا غیرمستقیم منجر به تاثیر منفی، از هر نوعی و دامنه‌ای، برای بنگاه ZENBET، دیگر مشترکین و/یا اشخاص ثالث شده‌اند؛',
      subParagraphLetter72: 'b) فرد اطلاعات غلط ارائه کرده باشد؛',
      subParagraphLetter73: 'c) فرد از شرایط و ضوابط جشنواره تخطی کرده باشد؛',
      subParagraphLetter74: 'd) فرد قوانین بازی و/یا دیگر قوانین را در عمل زیرپا گذاشته است؛',
      subParagraphLetter75: `e) حساب فرد مسدود شده است.`,
    },
    ru: {
      siteTitle: "Ставь на US Open 2021!",
      rulesBtnText: "Правила",
      titleLine1: "Гарантированный*",
      titleLine2: "Кешбэк",
      titleLine3: "на US Open",
      titleLine4: "каждый день",
      btnGet: "Участвовать",
      conditionSpan1: "Регистрируйся",
      conditionText1: "или авторизуйся на сайте",
      conditionText2: "Ставь на",
      conditionSpan2: "US Open",
      conditionSpan3: "Забирай кешбэк",
      conditionText3: "каждый день",
      bkString: "Букмекерская контора ZENBET",
      rightString: "Все права защищены",
      footnoteText: '*подробнее в правилах Акции',
      supportText: "Email: support@zen.bet",
      rulesHeaderText: "Правила участия в Акции",
      paragraph1: '1. Акция проводится с 30.08.2021 г. по 12.09.2021 г.',
      paragraph2: '2. Сроки проведения Акции устанавливаются БК ZENBET и могут быть изменены в любое время без указания причин и дополнительных уведомлений.',
      paragraph3: '3. Участнику Акции необходимо в период проведения Акции зарегистрироваться или авторизоваться на сайте zen.bet, а также обязательно подтвердить свое участие в Акции нажатием на кнопку «Участвовать».',
      paragraph4: '4. Кешбэк начисляется в виде фрибета.',
      paragraph5: '5. Условия начисления фрибета (бесплатной ставки):',
      paragraph6: '6. Бонусы не начисляются в следующих случаях:',
      paragraph7: '7. БК ZENBET вправе отказать участнику Акции в начислении фрибета (бесплатной ставки), а также отстранить участника от участия в любых Акциях компании, признать недействительными любые действия участника, в отношении которого у БК ZENBET возникли обоснованные подозрения в том, что он заведомо недобросовестно осуществляет права на участие в Акции или злоупотребляет ими, искажает данные или извлекает выгоду из любой подделки данных, необходимых для участия в Акции, в том числе, но не ограничиваясь следующими действиями:',
      paragraph8: '8. В случае обнаружения любого из нарушений правил Акции БК ZENBET вправе запретить участнику получение фрибетов, аннулировать выигрыши, полученные с использованием бесплатных ставок и заблокировать аккаунт участника Акции.',
      paragraph9: '9. Условия использования фрибетов:',
      paragraph10: '10. В случае выигрыша ставки, оплаченной суммой фрибета, участнику Акции выплачивается только сумма выигрыша без учета суммы фрибета. Фрибет повторно не используется.',
      paragraph11: '11. Условия Акции могут быть изменены и дополнены в любое время без указания причин и дополнительных уведомлений.',
      paragraph12: '12. Использование фрибета подразумевает полное согласие участника Акции с настоящими Правилами.',
      tableLeftTopText:'Количество бонусов за день',
      tableCenterTopText:'Сумма бесплатной ставки (фрибет) в валюте',
      tableCurrencyRub:'RUB',
      tableCurrencyUsd:'USD',
      tableCurrencyEur:'EUR',
      tableCurrencyIrr:'IRR',
      tableCurrencyBrl:'BRL',
      tableCurrencyUah:'UAH',
      tableCurrencyKzt:'KZT',
      tableCurrencyPrb:'PRB',
      tableCurrencyTmt:'TMT',
      tableCurrencyMdl:'MDL',
      noFreebetText: 'бесплатная ставка не выдается',
      subParagraph51: '5.1. В Акции участвуют ставки, сделанные на любые события турнира US Open.',
      subParagraph52: '5.2. За все ставки из п.п. 5.1. Участнику Акции ежедневно начисляются бонусы в количестве:',
      subInnerParagraph521: '5.2.1. Выигрышная ставка: сумма выигрыша (эквивалент в долларах)*1%.',
      subInnerParagraph522: '5.2.2. Проигрышная ставка: сумма ставки (эквивалент в долларах)*5%.',
      subParagraph53: '5.3. За полученные бонусы Участнику Акции ежедневно будет начисляться фрибет. Сумма фрибета зависит от количества накопленных за день бонусов:',
      subParagraph54: '5.4. Если количество бонусов, накопленных за день меньше 2, бесплатная ставка не выдается.',
      subParagraph55: '5.5. Бесплатные ставки начисляются ежедневно с 00:00 до 03:00 UTC+3.',
      subParagraph61: '6.1. Ставка сделана на любой другой турнир, кроме US Open.',
      subParagraph62: '6.2. Ставка сделана с использованием бесплатной ставки.',
      subParagraph63: '6.3. Ставка уже была учтена в других акциях компании.',
      subParagraph64: '6.4. Ставка была продана участником Акции.',
      subParagraph91: '9.1. Фрибет может быть использован после проверки соответствия условиям, указанным в п. 5 настоящих Правил, в течение 7 дней.',
      subParagraph92: '9.2. Совершить бесплатную ставку можно только на всю сумму фрибета.',
      subParagraphLetter71: 'а) участник был уличен в действиях, которые повлекли или могут повлечь за собой неблагоприятные последствия различного типа и степени как для БК ZENBET, так и для иных участников и для третьих лиц;',
      subParagraphLetter72: 'б) в случае выявления факта предоставления участником сведений, не соответствующих действительности;',
      subParagraphLetter73: 'в) участник нарушает Правила Акции;',
      subParagraphLetter74: 'г) участник Акции нарушает Правила азартной игры и/или иные установленные правила;',
      subParagraphLetter75: 'д) аккаунт участника Акции заблокирован.',
    },
    kz: {
      siteTitle: "US Open 2021 үшін ұтыс тік!",
      rulesBtnText: "Ережелер",
      titleLine1: "Күн сайын",
      titleLine2: "US Open",
      titleLine3: "үшін кепілдікті*",
      titleLine4: "кешбэк",
      btnGet: "ҚАТЫСУ",
      conditionSpan1: "Сайтта тіркел",
      conditionText1: "немесе авторизациядан өт",
      conditionSpan2: "US Open",
      conditionText2: "үшін бәс тік",
      conditionText3: "Күн сайын",
      conditionSpan3: "кешбэк ал",
      bkString: "ZENBET букмекерлік кеңсесі",
      rightString: "Барлық құқық қорғалған",
      footnoteText: '*толығырақ Акция ережелерінде',
      supportText: "Email: support@zen.bet",
      rulesHeaderText: "Акцияға қатысу ережелері",
      paragraph1: '1. Акция 30.08.2021 ж. және 12.09.2021 ж. аралығында өткізіледі.',
      paragraph2: '2. Акцияны өткізу мерзімін ZENBET БК белгілейді және себебін түсіндірместен және қосымша хабарландыру жасамай кез келген уақытта өзгертілуі мүмкін.',
      paragraph3: '3. Акция қатысушысына Акция өткізілу барысында zen.bet сайтында тіркелу немесе авторизациядан өту, сондай-ақ «Қатысу» түймесін басу арқылы өзінің Акцияға қатысатынын растау қажет.',
      paragraph4: '4. Кешбэк фрибет түрінде есептеледі.',
      paragraph5: '5. Фрибетті (тегін ұтысты) есептеу шарттары:',
      paragraph6: '6. Бонустар келесі жағдайларда есептелмейді:',
      paragraph7: '7. ZENBET БК акцияға қатысушыға фрибетті (тегін бәсті) есептеуден бас тартуға құқылы, сонымен қатар ZENBET БК акцияға қатысу құқығын дұрыс пайдаланбайтын немесе ережелерге немқұрайлы қарайтын, акцияға қатысуға қажетті деректерді қолмен жасайтын немесе жалған деректер арқылы пайда көргісі келетін қатысушыларды компания келесі әрекеттермен шектелмей, ұйымдастырған кез келген акциядан шеттетуге құқығы бар, сонымен қатар:',
      paragraph8: '8. Акция ережелері кез келген жолмен бұзылған жағдайда, ZENBET БК қатысушының фрибеттерді алуына тыйым салуға, тегін ұтыстарды қолданып алынған ұтыстарды жоюға және Акцияға қатысушының аккаунтын бұғаттауға құқылы.',
      paragraph9: '9. Фрибеттерді пайдалану шарттары:',
      paragraph10: '10. Фрибет сомасымен төленген ұтысты ұтып алған жағдайда, Акцияға қатысушыға фрибеттер сомасын қоспағанда тек ұтыс сомасы ғана төленеді. Фрибет қайта қолданылмайды.',
      paragraph11: '11. Акцияның шарттары кез келген уақытта себебін түсіндірместен және алдын ала хабарландырмай өзгеруі және толықтырылуы мүмкін.',
      paragraph12: '12. Фрибетті қолдану акцияға қатысушының осы Ережелермен толығымен келісетінін білдіреді.',
      tableLeftTopText:'Бір күнгі бонустар саны',
      tableCenterTopText:'Тегін ұтыстың (фрибеттің) валютамен сомасы',
      tableCurrencyRub:'RUB',
      tableCurrencyUsd:'USD',
      tableCurrencyEur:'EUR',
      tableCurrencyIrr:'IRR',
      tableCurrencyBrl:'BRL',
      tableCurrencyUah:'UAH',
      tableCurrencyKzt:'KZT',
      tableCurrencyPrb:'PRB',
      tableCurrencyTmt:'TMT',
      tableCurrencyMdl:'MDL',
      noFreebetText: 'тегін ұтыс берілмейді',
      subParagraph51: '5.1. Акцияға кез келген US Open турнирінің оқиғаларына тігілген ұтыстар қатысады.',
      subParagraph52: '5.2. 5.1 тармақшаларының барлық ұтыстары үшін. Акция қатысушысына күн сайын мына мөлшерде бонустар есептеледі:',
      subInnerParagraph521: '5.2.1. Ұтыстық тігілетін ұтыс: ұтыс сомасы (USD баламасы)*1%.',
      subInnerParagraph522: '5.2.2. Ұтылысты тігілетін ұтыс: ұтыс сомасы (USD баламасы)*5%.',
      subParagraph53: '5.3. Алынған бонустар үшін Акция Қатысушысына күн сайын фрибет есептеледі. Фрибет сомасы бір күнде жиналған бонустар санына байланысты болады:',
      subParagraph54: '5.4. Бір күнде жиналған бонустардың саны 2 аз болса, тегін ұтыс берілмейді.',
      subParagraph55: '5.5. Тегін ұтыстар күн сайын 00:00 және 03:00 аралығында UTC+3 есептеледі.',
      subParagraph61: '6.1. Ұтыс US Open-нен басқа кез келген басқа турнирге тігіледі.',
      subParagraph62: '6.2. Ұтыс тегін ұтысты қолданып тігілген.',
      subParagraph63: '6.3. Ұтыс әлдеқашан компанияның басқа акцияларында есепке алынған.',
      subParagraph64: '6.4. Ұтыс Акцияға қатысушымен сатылған.',
      subParagraph91: '9.1. Фрибетті 7 күн барысында осы Ережелердің 5-тармағында көрсетілген шарттарға сәйкестігі тексерілгеннен кейін пайдалануға болады.',
      subParagraph92: '9.2. Тегін ұтысты тек фрибеттің бүкіл сомасына тігуге болады.',
      subParagraphLetter71: 'а) қатысушы ZENBET БК үшін де, басқа қатысушылар үшін де, үшінші тұлғалар үшін де әртүрлі түрдегі және дәрежедегі жағымсыз салдарға әкеп соқтырған немесе әкеп соғуы мүмкін әрекеттерді орындаған;',
      subParagraphLetter72: 'б) шындыққа сәйкес келмейтін ақпаратты ұсынғаны туралы факт анықталған жағдайда;',
      subParagraphLetter73: 'в) қатысушы Акция ережелерін бұзады;',
      subParagraphLetter74: 'г) Акцияға қатысушы құмар ойындарының ережелерін және/немесе басқа белгіленген ережелерді бұзады;',
      subParagraphLetter75: 'д) Акцияға қатысушының аккаунты бұғатталған.',
    },
  },
  cupis: {
    ru: {
      siteTitle: "Ставь на US Open 2021!",
      rulesBtnText: "Правила",
      titleLine1: "Гарантированный*",
      titleLine2: "Кешбэк",
      titleLine3: "на US Open",
      titleLine4: "каждый день",
      btnGet: "Участвовать",
      conditionSpan1: "Регистрируйся",
      conditionText1: "или авторизуйся на сайте",
      conditionText2: "Ставь на",
      conditionSpan2: "US Open",
      conditionSpan3: "Забирай кешбэк",
      conditionText3: "каждый день",
      bkString: "Букмекерская контора «Зенит»",
      rightString: "Все права защищены",
      footnoteText: '*подробнее в правилах Акции',
      supportText: "Служба поддержки:",
      supportSpan: "8 (800) 222-55-50",
      rulesHeaderText: "Правила участия в Акции",
      paragraph1: '1. Акция проводится с 30.08.2021 г. по 12.09.2021 г.',
      paragraph2: '2. Сроки проведения Акции устанавливаются БК «Зенит» и могут быть изменены в любое время без указания причин и дополнительных уведомлений.',
      paragraph3: '3. Участнику Акции необходимо в период проведения Акции зарегистрироваться или авторизоваться на сайте zenit.win, а также обязательно подтвердить свое участие в Акции нажатием на кнопку «Участвовать».',
      paragraph4: '4. Кешбэк начисляется в виде фрибета.',
      paragraph5: '5. Условия начисления фрибета (бесплатной ставки):',
      paragraph6: '6. Бонусы не начисляются в следующих случаях:',
      paragraph7: '7. БК «Зенит» вправе отказать участнику Акции в начислении фрибета (бесплатной ставки), а также отстранить участника от участия в любых Акциях компании, признать недействительными любые действия участника, в отношении которого у БК «Зенит» возникли обоснованные подозрения в том, что он заведомо недобросовестно осуществляет права на участие в Акции или злоупотребляет ими,  искажает данные или извлекает выгоду из любой подделки данных, необходимых для участия в Акции, в том числе, но не ограничиваясь следующими действиями:',
      paragraph8: '8. В случае обнаружения любого из нарушений правил Акции БК «Зенит» вправе запретить участнику получение фрибетов, аннулировать выигрыши, полученные с использованием бесплатных ставок и заблокировать аккаунт участника Акции.',
      paragraph9: '9. Условия использования фрибетов:',
      paragraph10: '10. В случае выигрыша ставки, оплаченной суммой фрибета, участнику Акции выплачивается только сумма выигрыша без учета суммы фрибета. Фрибет повторно не используется.',
      paragraph11: '11. Условия Акции могут быть изменены и дополнены в любое время без указания причин и дополнительных уведомлений.',
      paragraph12: '12. Использование фрибета подразумевает полное согласие участника Акции с настоящими Правилами.',
      tableLeftTopText:'Количество бонусов за день',
      tableCenterTopText:'Сумма бесплатной ставки (фрибет) в валюте',
      tableCurrencyRub:'RUB',
      tableCurrencyUsd:'USD',
      tableCurrencyEur:'EUR',
      tableCurrencyIrr:'IRR',
      tableCurrencyBrl:'BRL',
      tableCurrencyUah:'UAH',
      tableCurrencyKzt:'KZT',
      tableCurrencyPrb:'PRB',
      tableCurrencyTmt:'TMT',
      tableCurrencyMdl:'MDL',
      subParagraph51: '5.1. В Акции участвуют ставки, сделанные на любые события турнира US Open.',
      subParagraph52: '5.2. За все ставки из п.п. 5.1. Участнику Акции ежедневно начисляются бонусы в количестве:',
      subInnerParagraph521: '5.2.1. Выигрышная ставка: сумма выигрыша (эквивалент в рублях)*1%.',
      subInnerParagraph522: '5.2.2. Проигрышная ставка: сумма ставки (эквивалент в рублях)*5%.',
      subParagraph53: '5.3. За полученные бонусы Участнику Акции ежедневно будет начисляться фрибет. Сумма фрибета зависит от количества накопленных за день бонусов:',
      subParagraph54: '5.4. Если количество бонусов, накопленных за день меньше 100, бесплатная ставка не выдается.',
      subParagraph55: '5.5. Бесплатные ставки начисляются ежедневно с 00:00 до 03:00 UTC+3.',
      subParagraph61: '6.1. Ставка сделана на любой другой турнир, кроме US Open.',
      subParagraph62: '6.2. Ставка сделана с использованием бесплатной ставки.',
      subParagraph63: '6.3. Ставка уже была учтена в других акциях компании.',
      subParagraph64: '6.4. Ставка была продана участником Акции.',
      subParagraph91: '9.1. Фрибет может быть использован после проверки соответствия условиям, указанным в п. 5 настоящих Правил, в течение 7 дней.',
      subParagraph92: '9.2. Совершить бесплатную ставку можно только на всю сумму фрибета.',
      subParagraphLetter71: 'а) участник был уличен в действиях, которые повлекли или могут повлечь за собой неблагоприятные последствия различного типа и степени как для БК «Зенит», так и для иных участников и для третьих лиц;',
      subParagraphLetter72: 'б) в случае выявления факта предоставления участником сведений, не соответствующих действительности;',
      subParagraphLetter73: 'в) участник нарушает Правила Акции;',
      subParagraphLetter74: 'г) участник Акции нарушает Правила азартной игры и/или иные установленные правила;',
      subParagraphLetter75: 'д) аккаунт участника Акции заблокирован.'
    }
  }
}
